let html = `<div class="console">
    <div class="console__tabs"></div>
    <div class="console__body"></div>
</div>`

export default html